import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateOperatingMode',
})
export class TranslateOperatingModePipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (value && this.customTranslationsService.OPERATING_MODES[value]) {
      return this.translateService.instant(this.customTranslationsService.OPERATING_MODES[value]);
    }

    return value;
  }
}
